import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CardScrollerComponent } from "./card-scroller.component";
import { CardHeaderModule } from "../card-header/card-header.module";
import { CardModule } from "primeng/card";


@NgModule({
    imports: [
        CommonModule,
        CardHeaderModule,
        CardModule
    ],
    declarations: [
        CardScrollerComponent
    ],
    exports: [
        CardScrollerComponent
    ]
})
export class CardScrollerModule {}